<template>
  <div class="p-6 bg-gray-100 min-h-screen">
    <div class="bg-white shadow-md rounded-lg p-6 mb-6">
      <div class="flex justify-between items-center mb-6">
        <h1 class="text-2xl font-bold text-gray-800">积分公示管理</h1>
        <div class="flex space-x-4">
          <button 
            @click="createPublic"
            class="px-4 py-2 bg-red-500 text-white font-medium rounded-lg hover:bg-red-600 transition-colors duration-300 flex items-center"
          >
            <svg class="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 6v6m0 0v6m0-6h6m-6 0H6"></path>
            </svg>
            发起公示
          </button>
        </div>
      </div>

      <!-- 统计卡片 -->
      <div class="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8">
        <div class="bg-white rounded-lg shadow p-4 border-l-4 border-green-500">
          <div class="flex items-center">
            <div class="p-3 rounded-full bg-green-100 mr-4">
              <svg class="w-6 h-6 text-green-500" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"></path>
              </svg>
            </div>
            <div>
              <p class="text-sm text-gray-500 font-medium">本月公示期数</p>
              <p class="text-2xl font-bold text-gray-800">3</p>
            </div>
          </div>
        </div>
        <div class="bg-white rounded-lg shadow p-4 border-l-4 border-blue-500">
          <div class="flex items-center">
            <div class="p-3 rounded-full bg-blue-100 mr-4">
              <svg class="w-6 h-6 text-blue-500" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197M13 7a4 4 0 11-8 0 4 4 0 018 0z"></path>
              </svg>
            </div>
            <div>
              <p class="text-sm text-gray-500 font-medium">公示积分人次</p>
              <p class="text-2xl font-bold text-gray-800">246</p>
            </div>
          </div>
        </div>
        <div class="bg-white rounded-lg shadow p-4 border-l-4 border-yellow-500">
          <div class="flex items-center">
            <div class="p-3 rounded-full bg-yellow-100 mr-4">
              <svg class="w-6 h-6 text-yellow-500" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"></path>
              </svg>
            </div>
            <div>
              <p class="text-sm text-gray-500 font-medium">收到异议数</p>
              <p class="text-2xl font-bold text-gray-800">12</p>
            </div>
          </div>
        </div>
      </div>

      <!-- 公示列表 -->
      <div class="overflow-hidden shadow-md border border-gray-200 rounded-lg">
        <table class="min-w-full divide-y divide-gray-200">
          <thead class="bg-gray-50">
            <tr>
              <th scope="col" class="px-6 py-3 text-left text-xs font-semibold text-gray-500 uppercase tracking-wider">期数</th>
              <th scope="col" class="px-6 py-3 text-left text-xs font-semibold text-gray-500 uppercase tracking-wider">公示开始日期</th>
              <th scope="col" class="px-6 py-3 text-left text-xs font-semibold text-gray-500 uppercase tracking-wider">公示结束日期</th>
              <th scope="col" class="px-6 py-3 text-left text-xs font-semibold text-gray-500 uppercase tracking-wider">积分记录数</th>
              <th scope="col" class="px-6 py-3 text-left text-xs font-semibold text-gray-500 uppercase tracking-wider">异议数量</th>
              <th scope="col" class="px-6 py-3 text-left text-xs font-semibold text-gray-500 uppercase tracking-wider">状态</th>
              <th scope="col" class="px-6 py-3 text-left text-xs font-semibold text-gray-500 uppercase tracking-wider">操作</th>
            </tr>
          </thead>
          <tbody class="bg-white divide-y divide-gray-200">
            <tr v-for="(item, index) in publicList" :key="index" class="hover:bg-gray-50 transition-colors duration-200">
              <td class="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">{{ item.period }}</td>
              <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500">{{ item.startDate }}</td>
              <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500">{{ item.endDate }}</td>
              <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500">{{ item.recordCount }}</td>
              <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500">{{ item.disputeCount }}</td>
              <td class="px-6 py-4 whitespace-nowrap">
                <span 
                  :class="[
                    'px-2 py-1 inline-flex text-xs font-semibold rounded-full',
                    item.status === 'active' ? 'bg-green-100 text-green-800' : 
                    item.status === 'ended' ? 'bg-gray-100 text-gray-800' :
                    'bg-blue-100 text-blue-800'
                  ]"
                >
                  {{ statusText(item.status) }}
                </span>
              </td>
              <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                <button 
                  @click="viewDetail(item)" 
                  class="text-blue-600 hover:text-blue-800"
                >
                  查看
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- 分页 -->
      <div class="flex justify-between items-center mt-6">
        <p class="text-sm text-gray-700">
          显示 <span class="font-medium">1</span> 至 <span class="font-medium">5</span> 条，共 <span class="font-medium">12</span> 条
        </p>
        <div class="flex space-x-2">
          <button class="px-3 py-1 border border-gray-300 rounded-md text-gray-700">
            上一页
          </button>
          <button class="px-3 py-1 border border-red-500 bg-red-500 text-white rounded-md">
            1
          </button>
          <button class="px-3 py-1 border border-gray-300 rounded-md text-gray-700">
            2
          </button>
          <button class="px-3 py-1 border border-gray-300 rounded-md text-gray-700">
            3
          </button>
          <button class="px-3 py-1 border border-gray-300 rounded-md text-gray-700">
            下一页
          </button>
        </div>
      </div>
    </div>

    <!-- 新增公示对话框 -->
    <div v-if="showModal" class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
      <div class="bg-white rounded-lg max-w-2xl w-full">
        <!-- 对话框头部 -->
        <div class="flex justify-between items-center border-b px-6 py-4">
          <h3 class="text-lg font-semibold text-gray-800">发起新公示</h3>
          <button @click="closeModal" class="text-gray-400 hover:text-gray-500">
            <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path>
            </svg>
          </button>
        </div>
        
        <!-- 对话框内容 -->
        <div class="px-6 py-4">
          <form @submit.prevent="submitForm">
            <div class="mb-4">
              <label for="title" class="block text-sm font-medium text-gray-700 mb-1">公示标题</label>
              <input 
                type="text" 
                id="title" 
                v-model="form.title" 
                class="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-red-500 focus:border-red-500"
                required
              />
            </div>
            
            <div class="mb-4 grid grid-cols-2 gap-4">
              <div>
                <label for="startDate" class="block text-sm font-medium text-gray-700 mb-1">开始日期</label>
                <input 
                  type="date" 
                  id="startDate" 
                  v-model="form.startDate" 
                  class="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-red-500 focus:border-red-500"
                  required
                />
              </div>
              <div>
                <label for="endDate" class="block text-sm font-medium text-gray-700 mb-1">结束日期</label>
                <input 
                  type="date" 
                  id="endDate" 
                  v-model="form.endDate" 
                  class="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-red-500 focus:border-red-500"
                  required
                />
              </div>
            </div>

            <div class="mb-4">
              <label for="departments" class="block text-sm font-medium text-gray-700 mb-1">选择部门</label>
              <select 
                id="departments" 
                v-model="form.departments" 
                multiple
                class="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-red-500 focus:border-red-500"
                required
              >
                <option value="all">全部部门</option>
                <option value="tech">技术部</option>
                <option value="sales">销售部</option>
                <option value="hr">人力资源部</option>
                <option value="finance">财务部</option>
                <option value="marketing">市场部</option>
              </select>
              <p class="text-xs text-gray-500 mt-1">按住Ctrl键可多选</p>
            </div>

            <div class="mb-4">
              <label for="dateRange" class="block text-sm font-medium text-gray-700 mb-1">积分记录时间范围</label>
              <div class="grid grid-cols-2 gap-4">
                <input 
                  type="date" 
                  id="scoreStartDate" 
                  v-model="form.scoreStartDate" 
                  class="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-red-500 focus:border-red-500"
                  required
                />
                <input 
                  type="date" 
                  id="scoreEndDate" 
                  v-model="form.scoreEndDate" 
                  class="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-red-500 focus:border-red-500"
                  required
                />
              </div>
            </div>

            <div class="mb-4">
              <label for="description" class="block text-sm font-medium text-gray-700 mb-1">公示说明</label>
              <textarea 
                id="description" 
                v-model="form.description" 
                rows="3"
                class="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-red-500 focus:border-red-500"
              ></textarea>
            </div>

            <div class="flex justify-end space-x-3 pt-4 border-t border-gray-200">
              <button 
                type="button" 
                @click="closeModal" 
                class="px-4 py-2 border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500"
              >
                取消
              </button>
              <button 
                type="submit" 
                class="px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-red-600 hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500"
              >
                发起公示
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PublicManagement',
  data() {
    return {
      showModal: false,
      form: {
        title: '',
        startDate: '',
        endDate: '',
        departments: [],
        scoreStartDate: '',
        scoreEndDate: '',
        description: ''
      },
      publicList: [
        {
          id: 1,
          period: '2024年7月第1期',
          startDate: '2024-07-01',
          endDate: '2024-07-07',
          recordCount: 85,
          disputeCount: 5,
          status: 'ended'
        },
        {
          id: 2,
          period: '2024年7月第2期',
          startDate: '2024-07-15',
          endDate: '2024-07-21',
          recordCount: 92,
          disputeCount: 7,
          status: 'ended'
        },
        {
          id: 3,
          period: '2024年7月第3期',
          startDate: '2024-07-29',
          endDate: '2024-08-04',
          recordCount: 69,
          disputeCount: 0,
          status: 'active'
        }
      ]
    }
  },
  methods: {
    statusText(status) {
      const statusMap = {
        'active': '公示中',
        'ended': '已结束',
        'pending': '待公示'
      };
      return statusMap[status] || status;
    },
    createPublic() {
      // 设置默认日期，当前日期+1天作为开始日期，+8天作为结束日期
      const tomorrow = new Date();
      tomorrow.setDate(tomorrow.getDate() + 1);
      const endDay = new Date();
      endDay.setDate(endDay.getDate() + 8);
      
      this.form = {
        title: `${new Date().getFullYear()}年${new Date().getMonth() + 1}月第${this.publicList.length + 1}期积分公示`,
        startDate: this.formatDate(tomorrow),
        endDate: this.formatDate(endDay),
        departments: ['all'],
        scoreStartDate: this.formatDate(new Date(new Date().setDate(1))), // 本月1日
        scoreEndDate: this.formatDate(new Date()),
        description: ''
      };
      this.showModal = true;
    },
    viewDetail(item) {
      // 查看公示详情
      alert(`查看公示详情：${item.period}`);
    },
    closeModal() {
      this.showModal = false;
    },
    submitForm() {
      // 检查结束日期是否大于开始日期
      if (new Date(this.form.endDate) <= new Date(this.form.startDate)) {
        alert('结束日期必须大于开始日期');
        return;
      }
      
      // 检查积分记录结束日期是否大于开始日期
      if (new Date(this.form.scoreEndDate) <= new Date(this.form.scoreStartDate)) {
        alert('积分记录结束日期必须大于开始日期');
        return;
      }
      
      // 处理表单提交，添加新的公示记录
      const newRecord = {
        id: this.publicList.length + 1,
        period: this.form.title,
        startDate: this.form.startDate,
        endDate: this.form.endDate,
        recordCount: Math.floor(Math.random() * 50) + 50, // 模拟数据
        disputeCount: 0,
        status: 'pending'
      };
      
      this.publicList.unshift(newRecord);
      
      // 关闭模态框
      this.closeModal();
      
      // 显示成功提示
      alert('发起公示成功');
    },
    formatDate(date) {
      const d = new Date(date);
      let month = '' + (d.getMonth() + 1);
      let day = '' + d.getDate();
      const year = d.getFullYear();
      
      if (month.length < 2) month = '0' + month;
      if (day.length < 2) day = '0' + day;
      
      return [year, month, day].join('-');
    }
  }
}
</script> 